// NOTE:
// Only variables that start with VUE_APP_ will be statically embedded into the client bundle with
// about the app environment variables, see:
// https://cli.vuejs.org/guide/mode-and-env.html#modes

export default {
  auth: true,
  matlsApiUrl: process.env.VUE_APP_MATLS_API_URL,
  iceLinkServerAddress: process.env.VUE_APP_ICE_LINK_SERVER_ADDRESS,
  chatServiceUrl: process.env.VUE_APP_CHAT_SERVICE_URL,
  webSyncServerUrl: process.env.VUE_APP_WEBSYNC_SERVER_URL,
  fudaoServiceUrl: process.env.VUE_APP_FUDAO_SERVICE_URL || ''
  // chatServiceUrl: 'http://192.168.0.216:8091/Langyan',
  // webSyncServerUrl: 'http://192.168.0.216:8091/Langyan/websync.ashx'
};